import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { TransactionsReport } from "../../../components/Reports/TransactionsReport";

export interface ITransactionsReportAdminPage {}

export const TransactionsReportAdminPage: FC<ITransactionsReportAdminPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Transactions Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<TransactionsReport />}
    />
  );
};
